import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { authData } from 'src/app/util/auth';
import { environment } from '../../../../environments/environment';
import { errorHandler } from '../../../util/errorHandler';
import { StudentGuardiansDTO } from 'src/app/models/studentGuardianDto';
import { getImageUrl, getLabel } from 'src/app/util/helpers';

@Component({
  selector: 'app-bio-data-guardian-list',
  templateUrl: './bio-data-guardian-list.component.html',
  styleUrls: ['./bio-data-guardian-list.component.scss']
})
export class BioDataGuardianListComponent implements OnInit {

  constructor(private httpClient: HttpClient, private router: Router) { }
  guardianToBeDeletedId: string = "";
  showDeleteDialog: boolean = false;
  states: any = [];
  ChildLeavingWith: any = [];
  _auth = authData();
  guardian : StudentGuardiansDTO = {
    GuardianID: "",
    FamilyID: this._auth.Student.FamilyID,
    Name: "",
    PhoneNumber: "",
    RelationshipWithChild: "",
    PrimaryGuardian: false,
    HomeAddress: "",
    City: "",
    State: "",
    Email: "",
    OfficeAddress: "",
    PrimaryGuardianLabel: "No",
    ImageType: "jpeg",
    ImageUrl: 'https://www.gravatar.com/avatar/?d=mp',
    PassportData: "",
    ImageSize: 0
  };
  guardianToSave:StudentGuardiansDTO = this.guardian;
  showFormDialog: boolean = false;
  GuadiansDTO:StudentGuardiansDTO[] | any= [
  ];
  
  url: any = null;
  studentPassport = null;
  payload: any = {
  };

  loading = false;
  skeletonLoader = true;
  notification = {};

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this._auth.Token,
    }),
  };

  ngOnInit(): void {
    this.getGuardians();
    this.getStates();
    this.getRelationshipsWithChild();
  }
  getStates() {
    this.skeletonLoader = true;
    const baseUrl = `${environment.BASE_URL}/biodata/states`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.states = res.Data || [];
      },
      (err) => {
      }
    );
  }

  getRelationshipsWithChild() {
    this.skeletonLoader = true;
    const baseUrl = `${environment.BASE_URL}/biodata/RelationshipsWithChild`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.ChildLeavingWith = res.Data || [];
      },
      (err) => {
      }
    );
  }
  getGuardians() {
    this.skeletonLoader = true;
    const baseUrl = `${environment.BASE_URL}/biodata/Guardians`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.GuadiansDTO = [...res.Data];

        this.GuadiansDTO =
          this.GuadiansDTO.map((el: any) => {
            return {
              ...el,
              FamilyID: this._auth.Student.FamilyID,
              PrimaryGuardianLabel: getLabel(el.PrimaryGuardian),
              ImageUrl: getImageUrl(el.PassportData)
            };
          });
          this.skeletonLoader = false;
      },
      (err) => {
        this.skeletonLoader = false;
      }
    );
  }

  closeForm() {
    this.guardianToSave = this.guardian;
    this.getGuardians();
    this.showFormDialog = false;
  }
  saveGuardian() {
    this.loading = true;
    this.notification = {};

    const baseUrl = `${environment.BASE_URL}/biodata/SaveGuardian`;
    this.httpClient.post(baseUrl, this.guardianToSave, this.httpOptions).subscribe(
      (res) => {
        this.loading = false;
        this.notification = {
          error: false,
          message: "Guardian saved successfully!",
        };
        this.closeForm();
      },
      (err) => {
        this.loading = false;
        this.notification = errorHandler(err);
      }
    );

  }
  editGuardian(index: number) {
    this.guardianToSave = this.GuadiansDTO[index];
    this.showFormDialog = true;
  }
  editGuardianList() {
    this.router.navigateByUrl("/bio-data/guardian-list-edit")
  }
  toggleDeleteDialog(guardianId: string) {
    this.guardianToBeDeletedId = guardianId;
    this.showDeleteDialog = true;
  }
  deleteGuardian(shouldDelete: boolean) {
    this.showDeleteDialog = false;
    if (shouldDelete) {
      
      this.loading = true;
      this.notification = {};

      const baseUrl = `${environment.BASE_URL}/biodata/DeleteGuardian?guardianId=${this.guardianToBeDeletedId}`;
      this.httpClient.delete(baseUrl, this.httpOptions).subscribe(
        (res) => {
          this.loading = false;
          this.notification = {
            error: false,
            message: "Guardian deleted successfully!",
          };
          this.getGuardians();
        },
        (err) => {
          this.loading = false;
          this.notification = errorHandler(err);
        }
      );
    }
  }

  totalGuardians(): any[] {
    return new Array(this.GuadiansDTO.length);
  }

  addGuardian() {
    this.guardianToSave = this.guardian;
    this.showFormDialog = true;
  }

  toggleCheckBox(variable: string, i: number) {
    this.GuadiansDTO[i][variable] = !this.GuadiansDTO[i][variable];
    this.GuadiansDTO[i][`${variable}Label`] = getLabel(this.GuadiansDTO[i][variable]);
  }

}
